<template>
	<div :class="['matching--item', category, {'matching--item-clickable': clickable}]" @click="onClick">
		<div v-if="label || comparisonGroup" class="label">
			<span v-if="label">{{ label }}</span>
			<div v-if="comparisonGroup" class="comparison-group">
				<div v-if="comparisonGroup.irrelevant">Egal für Kandidat</div>
				<div v-if="comparisonGroup.none">Keine erwünscht</div>
				<div
					v-for="item in comparisonGroup.items"
					:key="item.id"
					:class="['comparison-group-item', { 'has-items': item.subItems.length > 0 }]"
				>
					<div class="comparison-group-item-title" v-html="item.label"/>
					<ul v-if="item.subItems.length > 0" class="comparison-group-item-sub-items mt-1">
						<li
							v-for="(subItem, i) in item.subItems"
							:key="'sub-item-' + i"
							:class="{'extra': subItem.extra}"
						>
							{{ subItem.label }}
							<ul v-if="subItem.subItems.length > 0" class="mt-1">
								<li
									v-for="(subItem, i) in subItem.subItems"
									:key="'sub-sub-item-' + i"
									:class="{'extra': subItem.extra}"
								>
									{{ subItem.label }}
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<template v-if="showBar">
			<div class="score-container">
				<div v-if="sectionCompleted === false && eligible === true">Hier fehlen noch Infos von dir.</div>
				<div v-else-if="maxScore > 0" class="bar">
					<div class="inner" :style="{ width: percentage + '%' }">&nbsp;</div>
				</div>
			</div>
			<div v-if="withPercentage" class="percentage-container">{{ percentage }}%</div>
			<div v-if="infoText" class="info-container">
				<span v-b-tooltip :title="infoTextComputed">
					<Icon icon="info"/>
				</span>
			</div>
		</template>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import Icon from "@/vue/icon/Icon.vue";

export default {
	components: {
		Icon,
		Button
	},

	props: {
		label: {
			type: String,
			required: false,
		},
		score: {
			type: Number,
			required: true,
		},
		maxScore: {
			type: Number,
			required: true,
		},
		comparisonGroup: {
			type: Object,
			required: false,
		},
		sectionCompleted: {
			type: Boolean,
			required: false,
			default: undefined,
		},
		eligible: {
			type: Boolean,
			required: false,
			default: undefined,
		},
		clickable: {
			type: Boolean,
			required: false,
			default: false,
		},
		withPercentage: {
			type: Boolean,
			required: false,
			default: false,
		},
		infoText: {
			type: String,
			required: false
		},
	},

	computed: {
		showBar ()
		{
			return !this.comparisonGroup || !this.comparisonGroup.noRequirements;
		},
		percentage ()
		{
			return Math.round(this.score / this.maxScore * 100);
		},
		infoTextComputed ()
		{
			if (!this.infoText)
			{
				return undefined;
			}

			return this.infoText.replaceAll('#percentage#', this.percentage.toString());
		},
		category ()
		{
			const percentage = this.percentage;

			if (percentage === 0)
			{
				return 'none';
			}

			if (percentage < 30)
			{
				return 'ok';
			}

			if (percentage < 60)
			{
				return 'good';
			}

			return 'perfect';
		},
	},

	methods: {
		onClick (e)
		{
			if (!this.clickable)
			{
				return;
			}

			e.preventDefault();

			this.$emit('click');
		}
	}
}
</script>
